/**
 * テナントが扱える排出事業者
 */
import Vue from 'vue'
import { DRIVER_ENDPOINT } from '../../../../../../constants/httpConst'

const master_emission_location_remove_confirmation = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { emission_id, location_id }) {
      const api_path = `${DRIVER_ENDPOINT}/masters/emissions/${emission_id}/locations/${location_id}/remove_confirmations`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default master_emission_location_remove_confirmation
